//import one from '../assets/svg/projects/one.svg'
//import two from '../assets/svg/projects/two.svg'
//import three from '../assets/svg/projects/three.svg'
//import four from '../assets/svg/projects/four.svg'
//import five from '../assets/svg/projects/five.svg'
//import six from '../assets/svg/projects/six.svg'
//import seven from '../assets/svg/projects/seven.svg'
//import eight from '../assets/svg/projects/eight.svg'
//import nine from '../assets/svg/projects/nine.svg'
//import ten from '../assets/svg/projects/ten.svg'
//import eleven from '../assets/svg/projects/eleven.svg'
//import twelve from '../assets/svg/projects/twelve.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Green Grocery',
        projectDesc: 'This project is a website where customers can buy vegetables directly from farmers for low rates compared to the market.',
        tags: ['MongoDB','Express','React','Node JS'],
        code: 'https://github.com/rakesh6451/Slytherin',
        demo: 'http://greengrocery30.herokuapp.com/',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663490308/samples/GreenGrocery_qoytd2.png'
    },
    {
        id: 2,
        projectName: 'Intrusion Detection System',
        projectDesc: 'An effective IDS using Machine learning and Deep learning algorithms. Used Benchmark Datasets available and improved the existing algorithms.In Machine Learning Algorithms: Naive Bayes Classifier, Decision Tree and Voting Classifier performed with good accuracy.',
        tags: ['Python','OOPS'],
        code: 'https://github.com/rakesh6451/Intrusion-Detection-System',
        demo: 'https://github.com/rakesh6451/Intrusion-Detection-System',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667628765/ids-in-security_tpkbql.png'
    },
    {
        id: 3,
        projectName: 'Book Space',
        projectDesc: 'This project aims at making book services available to everyone at low costs on a single click.',
        tags: ['HTML', 'CSS', 'JS','Django'],
        code: 'https://github.com/rakesh6451/BookSpace',
        demo: 'http://anirudhjak.pythonanywhere.com/',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663495313/samples/Bookspace_yxec4i.png'
    },
    {
        id: 4,
        projectName: 'Solar System',
        projectDesc: 'This project is written in OpenGL that will accurately animate the Solar System which can’t be captured by an actual camera precisely.',
        tags: ['OpenGL', 'Computer Graphics','Animation'],
        code: 'https://github.com/rakesh6451/Solar-System-Computer-Graphics-',
        demo: 'https://github.com/rakesh6451/Solar-System-Computer-Graphics-',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663496042/samples/SolarSystem_dektlq.png'
    },
    
    {
        id: 5,
        projectName: 'IR Ranked Retrieval',
        projectDesc: 'This IR system is going to rank the top k documents of captions dataset',
        tags: ['Information Retrieval'],
        code: 'https://github.com/rakesh6451/IR-Ranked-Retrieval-',
        demo: 'https://github.com/rakesh6451/IR-Ranked-Retrieval-',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667635760/it_chsscl.jpg'
    },

    {
        id: 6,
        projectName: 'Regression Analysis in R',
        projectDesc: 'This project performs the Regression Analysis in R. It performs simple linear regression analysis, simple non-linear regression analysis and calculating R^2 values.',
        tags: ['R', 'Regression-Analysis','Correlational-Analysis'],
        code: 'https://github.com/rakesh6451/Life-Expectancy--Using-R',
        demo: 'https://github.com/rakesh6451/Life-Expectancy--Using-R',
        image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1667635858/life_pvv8td.jpg'
    },

    {
        id: 7,
        projectName: 'Slytherin Game',
        projectDesc: 'Built a 2D Snake game using pygame module including many multimedia functionalities like images, audio and video.',
        tags: ['Python', 'Pygame','Multimedia'],
        code: 'https://github.com/rakesh6451/Slytherin',
        demo: 'https://github.com/rakesh6451/Slytherin',
        image: 'https://res.cloudinary.com/h2camp/image/upload/v1663497787/samples/Slytherin_pjhsos.png'
    },
    // {
    //     id: 7,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 8,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
